import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { ShieldAlert } from 'lucide-react';
import { loginStaff } from './api';
import { useBrandingStore } from '@shared/stores/brandingStore';
import { TextField } from '@shared/ui/primitives/TextField';
import { Button } from '@shared/ui/primitives/Button';
import { toast } from '@shared/ui/feedback/Toast';
import { env } from '@config/env';

export function LoginPage(): JSX.Element {
  const navigate = useNavigate();
  const brandingName = useBrandingStore((s) => s.branding?.name) ?? env.appName;
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [busy, setBusy] = useState(false);

  async function onSubmit(e: React.FormEvent) {
    e.preventDefault();
    setBusy(true);
    try {
      await loginStaff(email, password);
      navigate('/', { replace: true });
    } catch (err) {
      const msg = err instanceof Error ? err.message : 'Login failed';
      toast.danger(msg);
    } finally {
      setBusy(false);
    }
  }

  return (
    <div className="flex min-h-screen flex-col items-center justify-center bg-[#2a1214] px-6 text-[#f8f0ee]">
      <div className="mb-8 flex flex-col items-center gap-3 text-center">
        <div className="flex h-16 w-16 items-center justify-center rounded-full bg-[#b4544f]/30">
          <ShieldAlert className="h-8 w-8 text-[#e8a8a4]" />
        </div>
        <h1 className="text-2xl font-semibold">{brandingName}</h1>
        <p className="text-sm text-white/60">Security guard sign-in</p>
      </div>

      <form onSubmit={onSubmit} className="w-full max-w-sm space-y-4">
        <TextField
          label="Email"
          type="email"
          autoComplete="username"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          required
        />
        <TextField
          label="Password"
          type="password"
          autoComplete="current-password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          required
        />
        <Button type="submit" variant="primary" className="w-full" disabled={busy}>
          {busy ? 'Signing in…' : 'Sign in'}
        </Button>
      </form>
    </div>
  );
}
